// @flow

import React, { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { ContentUnavailableModal } from './ContentUnavailableModal'
import { useContentUnavailableHtml } from '../hooks'

export type ContentUnavailableProps = {
  isOpen: boolean,
  hide: () => void,
  meta: Object,
}

// eslint-disable-next-line complexity
export const ContentUnavailable = ({ isOpen, hide, meta }: ContentUnavailableProps) => {
  const navigate = useNavigate()
  const { loading, html } = useContentUnavailableHtml(meta?.kind)

  const handleGoBack = useCallback(() => {
    setTimeout(() => hide(), 100)
    navigate(-1)
  }, [hide, navigate])

  // eslint-disable-next-line complexity
  useEffect(() => {
    if (isOpen && !loading && !html) {
      hide()
    }
  }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!loading && !html) {
    return null
  }

  if (isOpen) {
    return <ContentUnavailableModal loading={loading} html={html} onBack={handleGoBack} />
  }

  return null
}

export default ContentUnavailable
